/*
Brushes
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Brushes'
const id = '7W2MUVvQWOcWPNfih8zU'

export default {
  name,
  id,
  filters,
  headers,
  form
}
